import React, { Component } from 'react';
import { Row, Col } from 'antd';
import StatItem from '../BaseComponents/StatItem';
import resources from '../../resources';
import StatItem1 from '../BaseComponents/StatItem1';
import StatItem2 from '../BaseComponents/StatItem2';
import StatItem3 from '../BaseComponents/StatItem3';
import StoreManager from '../../appdata';
import languages from '../../appdata/languages';

class Highlight2024Content extends Component {
  render() {
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].Highlight2024Content;
        const {isMobile} = StoreManager.appState.thisApp.state
    
    return (
      <div>
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 500, marginBottom: 24 }}>{content.title}</h2>

        <h3 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16 }}>{content.section1Title}</h3>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
          
            <StatItem1
              iconName={resources.icons.FinancialIcon1}
              title={content.item1.title}
              value={content.item1.value}
              message1={content.item1.message1}
              message2={content.item1.message2}
              colorValue="#E0582C"
              colorMessage1="#212121"
              colorMessage2="#1DAA45"
              bgColor="#EDF8FF"
            />
          </Col>
          <Col xs={24} md={12}>
           
             <StatItem1
              iconName={resources.icons.FinancialIcon2}
              title={content.item2.title}
              value={content.item2.value}
              message1={content.item2.message1}
              message2={content.item2.message2}
              colorValue="#E0582C"
              colorMessage1="#212121"
              colorMessage2="#212121"
              bgColor="#EDF8FF"
            />
          </Col>
          <Col xs={24} md={12}>

            <StatItem2
              iconName={resources.icons.FinancialIcon3}
              title={content.item3.title}
              value={content.item3.value}
              message1={content.item3.message1}
              message2=""
              message3=""
              colorValue="#E0582C"
              colorMessage1="#212121"
              colorMessage2="#212121"
            />

          </Col>
          <Col xs={24} md={12}>
            <StatItem2
              iconName={resources.icons.FinancialIcon4}
              title={content.item4.title}
              value={content.item4.value}
              message1={content.item4.message1}
              message2=""
              message3={content.item4.message3}
              colorValue="#E0582C"
            />

          </Col>
        </Row>

        <h3 style={{ fontSize: 20, fontWeight: 600, marginTop: 48, marginBottom: 16 }}>{content.section2Title}</h3>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
         
          <StatItem3
              title={content.item5.title}
              value={content.item5.value}
              message1={content.item5.message1}
            />

          </Col>
          <Col xs={24} md={12}>
             <StatItem3
              title={content.item6.title}
              value={content.item6.value}
              message1={content.item6.message1}
            />
          </Col>
        </Row>

        <h3 style={{ fontSize: 20, fontWeight: 600, marginTop: 48, marginBottom: 16 }}>{content.section3Title}</h3>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
          <StatItem3
              title={content.item7.title}
              value={content.item7.value}
              message1={content.item7.message1}
              type={2}
            />
          
          </Col>
        </Row>

        <h3 style={{ fontSize: 20, fontWeight: 600, marginTop: 48, marginBottom: 16 }}>{content.section4Title}</h3>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <StatItem3
                  title={content.item8.title}
                  value={content.item8.value}
              message1=""
            />
          </Col>
          <Col xs={24} md={12} >
            <StatItem3
        title={content.item9.title}
        value={content.item9.value}
              message1=""
            />
          </Col>
          <Col xs={24} md={12}>
          
            <StatItem3
              title={content.item10.title}
              value={content.item10.value}
              message1=""
              type={3}
            />
          </Col>
          <Col xs={24} md={12}>
            <StatItem3
              title={content.item11.title}
              value={content.item11.value}
              message1=""
              type={3}
            />
          </Col>
        </Row>

        <h3 style={{ fontSize: 20, fontWeight: 600, marginTop: 48, marginBottom: 12 }}>
        {content.section5Title}
        </h3>
        <p style={{ fontSize: 16, lineHeight: '22px', color: '#444' }}>
        {content.section5Description}
        </p>
      </div>
    );
  }
}

export default Highlight2024Content;